export const FACEBOOK = 'https://www.facebook.com/ljramosonline'
export const INSTAGRAM = 'https://www.instagram.com/ljramosonline/'
export const TWITTER = 'https://twitter.com/LJRamosonline'
export const GOOGLE = 'https://plus.google.com/u/0/113659156650501052558'
export const LINKEDIN = 'https://www.linkedin.com/company/1032286?goback=%2Efcs_GLHD_l*3j*3+ramos+_false_*2_*2_*2_*2_*2_*2_*2_*2_*2_*2_*2_*2&trk=ncsrch_hits'
export const YOUTUBE = 'https://www.youtube.com/channel/UCq_p8Fs2zGkyWJ5dwuY96ww'


//Id de la aplicación de facebook parar el social login
export const FB_APP_ID = '849801178455599'

//Id de la aplicación de goolge para el social login
export const GOOGLE_CLIENT_ID = '331566523420-u3tpn5idt7vcb9dd9ukr7ic9lu0rspo7.apps.googleusercontent.com'



// WEBPACK FOOTER //
// ./src/constants/socials.js